import React from 'react';
import { Colors } from '../../constants/Colors.js';

/**
 * Navegación de pestañas para tableros con más de dos vistas. Para dos vistas
 * usa TabButtons, que es el patrón del resto de la consola.
 *
 * tabs: [{ key, label, sublabel }]
 */
const TabsNav = ({ tabs, active, onChange }) => (
  <div className="d-flex flex-wrap" style={{ gap: 4, borderBottom: `1px solid ${Colors.neutral_100}`, marginBottom: 20 }} role="tablist">
    {tabs.map(tab => {
      const isActive = tab.key === active;
      return (
        <button
          key={tab.key}
          type="button"
          role="tab"
          aria-selected={isActive}
          onClick={() => onChange(tab.key)}
          className="btn"
          style={{
            border: 'none',
            borderRadius: '10px 10px 0 0',
            borderBottom: `2px solid ${isActive ? Colors.primary_500 : 'transparent'}`,
            backgroundColor: isActive ? Colors.neutral_3 : 'transparent',
            color: isActive ? Colors.primary_700 : Colors.gray_base,
            fontWeight: isActive ? 600 : 400,
            fontSize: '0.875rem',
            padding: '8px 16px',
            lineHeight: 1.3,
            textAlign: 'left',
          }}>
          <span className="d-block">{tab.label}</span>
          {tab.sublabel && (
            <small className="d-block" style={{ fontSize: '0.7rem', color: Colors.neutral_400, fontWeight: 400 }}>
              {tab.sublabel}
            </small>
          )}
        </button>
      );
    })}
  </div>
);

export default TabsNav;
